import { render, staticRenderFns } from "./choose_product.vue?vue&type=template&id=f3b8a996"
import script from "./choose_product.vue?vue&type=script&lang=js"
export * from "./choose_product.vue?vue&type=script&lang=js"
import style0 from "./choose_product.vue?vue&type=style&index=0&id=f3b8a996&lang=less&scepod=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3b8a996')) {
      api.createRecord('f3b8a996', component.options)
    } else {
      api.reload('f3b8a996', component.options)
    }
    module.hot.accept("./choose_product.vue?vue&type=template&id=f3b8a996", function () {
      api.rerender('f3b8a996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/contract/form/choose_product.vue"
export default component.exports